export const filterDuplicates = array => {
  return array.filter((elem, pos, arr) => {
    return arr.indexOf(elem) === pos;
  });
};



// WEBPACK FOOTER //
// ./src/utils/filter.js